<template>
   <div class="spin">
       <canvas id="canvas" width="2355" height="521"></canvas>
       <div style="position: absolute; left: 16px; top: 16px; display: flex; flex-direction: row; right: 16px;"> 
            <div>
              <img
                src="../assets/images/logo2.png"
                loading="lazy"
                style="height:100px;"
              />
            </div>
           <div style="display: flex; flex: 1; align-items: center; flex-end; justify-content: flex-end;">
              <div style="display: flex; align-items: center; gap: 8px; padding: 8px 16px; background: rgba(255, 107, 53, 0.15); border: 1px solid rgba(255, 107, 53, 0.4); border-radius: 50px; backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);">
                  <img src="../assets/images/coin.png" width="22" alt="Coin" />
                  <span style="font-family: 'Poppins', sans-serif; font-size: 14px; font-weight: 700; color: #FF9165; text-shadow: 0 0 10px rgba(255, 145, 101, 0.5);">{{ mycoin }}</span>
                </div>
                <span class="avatar" id="avatar" :style="{ 'background-image': `url(${pictureUrl})` }"></span>
          </div> 
      </div>
       <div style="position: absolute; bottom: 20px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
         <div style="display: flex; flex: 1; align-items: center; justify-content: center;">
              <div style="border-radius: 50px; margin-left: 0px; background: #2f2f2f; align-items: center; justify-content: center; display: flex; padding-left: 16px; padding-right: 16px; padding-top: 9px; padding-bottom: 9px;">
                  <span class="glow">
                    {{loadingtext}}
                  </span>
              </div>
          </div> 
       </div>
   </div>
</template>

<script>
import firebase, { firestore } from "firebase/app";
import "firebase/database";
import moment from "moment-timezone";
const axios = require("axios").default;
import router from "./../router";
import liffService from "@/services/liff";
// @ is an alias to /src
export default {
  name: "GoldenSpin",
  mounted() {
    // LIFF is already initialized by router guard
    this.loadUserData();
  },
  data() {
    return {
      loadingtext:'น้องออโต้กำลังประมวลผลให้อยู่ค่ะ รอสักครู่',
      displayName: "",
      //email: "",
      userId: "",//Uf67a993bc2d1d206693634a1ba806798
      pictureUrl: "",
      statusMessage: "",
      firstname: "",
      master: "5",
      agent: "-MBjPYX3fRJGs3gklUHq",
      lastname: "",
      bank: "",
      accountNo: "",
      tel: "",
      mastername: "",
      isDisabled: true,
      loading: true,
      error: "",
      mycoin:0,
      rewards:[],
      userKey:'',
      quizId:0,
      answer:0,
      running:false,
      angle:0,
      sections : ["30 Coins","50 Coins", "30 Coins", "100 Coins", "50 Coins", "30 Coins", "50 Coins", "30 Coins", "100 Coins", "50 Coins", "30 Coins", "300 Coins"],
      colors : ["#ea1a20", "#018ee9", "#ea1a20", "#01e964", "#018ee9", "#ea1a20", "#018ee9", "#ea1a20", "#01e964", "#018ee9", "#ea1a20", "#fecf3b"],
      //colors : ["#F84", "#8F4", "#48F", "#F8F","#F84", "#8F4", "#48F", "#F8F", "#F84", "#8F4", "#48F", "#F8F","#666666","#fcd846"],
      wheels:null,
      frame:null,
      canvas:null,
    };
  },
  methods: {
      repaint(angle) {
        const r = Math.min(innerWidth, innerHeight) / 2.25 | 0;
        if (this.wheels === null) {
            this.wheels = [];
            for (let selected=0; selected<this.sections.length; selected++) {
                const c = document.createElement("canvas");
                c.width = c.height = 2*r + 10;
                const ctx = c.getContext("2d"), cx = 5 + r, cy = 5 + r;
                const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
                g.addColorStop(0, "rgba(0,0,0,0)");
                g.addColorStop(1, "rgba(0,0,0,0.1)");
                for (let i=0; i<this.sections.length; i++) {
                    const a0 = 2*Math.PI*i/this.sections.length;
                    const a1 = a0 + 2*Math.PI/(i == 0 ? 1 : this.sections.length);
                    const a = 2*Math.PI*(i+0.5)/this.sections.length;
                    ctx.beginPath();
                    ctx.moveTo(cx, cy);
                    ctx.arc(cx, cy, r, a0, a1, false);
                    ctx.fillStyle = this.colors[i];
                    ctx.fill();
                    ctx.fillStyle = g;
                    ctx.fill();
                    ctx.save();
                    if (i == selected) {
                        ctx.fillStyle = "#FFF";
                        ctx.shadowColor = "#FFF";
                        ctx.shadowBlur = r/20;
                    } else {
                        ctx.fillStyle = "#000";
                    }
                    ctx.font = "bold " + r/this.sections.length*1.6 + "px serif";
                    ctx.textAlign = "center";
                    ctx.textBaseline = "middle";
                    ctx.translate(cx, cy);
                    ctx.rotate(a);
                    ctx.fillText(this.sections[i], r*0.62, 0);
                    ctx.restore();
                }
                this.wheels.push(c);
            }
        }
        if (this.frame === null) {
            this.frame = document.createElement("canvas");
            this.frame.width = this.frame.height = 10 + 2*r*1.25 | 0;
            const ctx = this.frame.getContext("2d"), cx = this.frame.width/2, cy = this.frame.height/2;
            ctx.shadowOffsetX = r/80;
            ctx.shadowOffsetY = r/80;
            ctx.shadowBlur = r/40;
            ctx.shadowColor = "rgba(0,0,0,0.5)";
            ctx.beginPath();
            ctx.arc(cx, cy, r*1.028, 0, 2*Math.PI, true);
            ctx.arc(cx, cy, r*0.975, 0, 2*Math.PI, false);
            ctx.fillStyle = "#ffbf00";
            ctx.fill();
            ctx.shadowOffsetX = r/40;
            ctx.shadowOffsetY = r/40;
            const g = ctx.createRadialGradient(cx-r/7, cy-r/7, 0, cx, cy, r/3);
            g.addColorStop(0, "#FFF");
            g.addColorStop(0.2, "#ffcf40");
            g.addColorStop(1, "#ffbf00");
            ctx.fillStyle = g;
            ctx.beginPath();
            ctx.arc(cx, cy, r/3.5, 0, 2*Math.PI, false);
            ctx.fill();
            ctx.translate(cx, cy);
            ctx.rotate(Math.PI - 0.18);
            ctx.beginPath();
            ctx.moveTo(- r*1.1, - r*0.07);
            ctx.lineTo(- r*0.85, 0);
            ctx.lineTo(- r*1.1, r*0.07);
            ctx.fillStyle = "#F44";
            ctx.fill();
        }
        this.canvas.width = innerWidth;
        this.canvas.height = innerHeight;
        const cx = innerWidth/2, cy = innerHeight/2;
        const ctx = this.canvas.getContext("2d");
        let selected = (Math.floor((- 0.2 - angle) * this.sections.length / (2*Math.PI))
                        % this.sections.length);
        if (selected < 0) selected += this.sections.length;
        ctx.save();
        ctx.translate(cx, cy);
        ctx.rotate(angle);
        ctx.translate(-this.wheels[selected].width/2, -this.wheels[selected].height/2);
        ctx.drawImage(this.wheels[selected], 0, 0);
        ctx.restore();
        ctx.drawImage(this.frame, cx - this.frame.width/2, cy - this.frame.height/2);
    },
    spinTo(winner, duration) {
        const finalAngle = (-0.2) - (0.5 + winner)*2*Math.PI/this.sections.length;
        const startAngle = this.angle - Math.floor(this.angle/(2*Math.PI))*2*Math.PI - 5*2*Math.PI;
        const start = performance.now();
        const frame = () => {
            const now = performance.now();
            let t = Math.min(1, (now - start) / duration);
            t = 3*t*t - 2*t*t*t; // ease in out
            this.angle = startAngle+t*(finalAngle-startAngle);
            this.repaint(this.angle);
            if (t < 1) requestAnimationFrame(frame); else {
                const coin = this.sections[winner].split(' ');
                firebase.firestore().collection('spin').doc(this.userId).set({
                  userId:this.userId,
                  createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
                  spin:this.sections[winner],
                  value:Number(coin[0])
                });
                if(Number(coin[0]) > 0){
                  this.mycoin += Number(coin[0]);
                  this.$confirm(
                    {
                      message: `ปังปุรีเย่!! คุณได้รับ ${this.sections[winner]} 😘😘`,
                      button: {
                        yes: 'OK'
                      },
                      callback: confirm => {
                        if (confirm) {
                          this.sendMessageLine(`ปังปุรีเย่!! คุณได้รับ ${this.sections[winner]} 😘😘`);
                        }
                      }
                    }
                  );
                }
            }
        }
        requestAnimationFrame(frame);
        this.running = true;
    },
    async sendMessageLine(text){
      await window.liff.sendMessages([
          {
              "type": "text",
              "text": "🎰 "+text,
          }
      ]);
      window.liff.closeWindow();
    },
    async loadUserData() {
      // Get profile from centralized service (already fetched by router guard)
      const profile = liffService.profile;
      if (!profile) return;

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";
      if (this.userId) {
          const user = (await firebase.database().ref(`/users`).orderByChild('userId').equalTo(this.userId).once("value")).val();
          if (user) {
              const u = user[Object.keys(user)[0]];
              this.mycoin = (u.coins)?u.coins:0;
              this.userKey = Object.keys(user)[0];
              await firebase.firestore().collection('spin').where('userId','==',this.userId).limit(1).get().then(async (snapshot) => {
                if(snapshot.size === 0){
                  this.canvas = document.getElementById("canvas");
                  this.repaint(this.angle);
                  this.loadingtext = 'น้องออโต้พร้อมแล้ว หมุนได้เลยค่ะ😘😘';
                  this.canvas.onmousedown = ()=> {
                        if (!this.running) {
                            const rand = this.randomFixed();
                            this.spinTo(rand, 5000);
                        }
                  };
                }else{
                  this.sendMessageLine("ลูกค้าหมุนวงล้อของเราไปแล้วนะคะ 😘😘");
                }
              });
          }else{
            router.replace("/register");
          }
      }
      this.isDisabled = false;
    },
    randomFixed(){
        let rand = Math.random()*this.sections.length|0;
        rand = 1;
        return rand;
    },
  }
};
</script>
<style scoped>
.glow {
            color: #fff;
            text-align: center;
            -webkit-animation: glow 1s ease-in-out infinite alternate;
            -moz-animation: glow 1s ease-in-out infinite alternate;
            animation: glow 1s ease-in-out infinite alternate;
            }

            @-webkit-keyframes glow {
            from {
                text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
            }
            
            to {
                text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
            }
        }
.spin { padding: 0px;
           margin: 0px;
           overflow: hidden;
           height: 100%;
/*background: rgb(255,204,92,1);
background: radial-gradient(circle, rgba(255,204,92,1) 49%, rgba(34,193,195) 100%);*/
background-image: url("../assets/images/loy-kratong-1021x580.jpg");
          background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; 
      
      }
</style>